import React, { useMemo, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/images/wordb_logo.svg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from '../components/Footer';
import Feedback from '../components/Feedback';
import Query from '../components/Query';
import { IoClose } from "react-icons/io5";
import { API } from '../config';

const LogIn = ({ onLogin }) => {
    const [params] = useSearchParams();
    const token = useMemo(() => params.get('token') || '', [params]);
    const [pwd1, setPwd1] = useState('');
    const [pwd2, setPwd2] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();


    const [isFeedbackOpen, setFeedbackOpen] = useState(false);
    const [isQueryOpen, setQueryOpen] = useState(false);
    const toggleFeedback = () => setFeedbackOpen(open => !open);
    const toggleQuery = () => setQueryOpen(open => !open);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!token) return toast.error('Invalid or missing reset link.');
        if (!pwd1 || !pwd2) return toast.error('Enter and confirm your new password.');
        if (pwd1 !== pwd2) return toast.error('Passwords do not match.');
        if (pwd1.length < 4) return toast.error('Password must be at least 4 characters.');

        setSubmitting(true);
        try {
            const { data } = await axios.post(`${API}/api/users/auth/reset-password`, {
                token, newPassword: pwd1, confirmPassword: pwd2,
            });
            // If you kept auto-login on backend:
            if (data?.token) localStorage.setItem('authToken', data.token);
            toast.success('Password updated.');
            navigate('/'); // or login page if you disabled auto-login
        } catch (e) {
            toast.error(e.response?.data?.message || 'Reset failed. The link may have expired.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />
            <section className='login signup'>

                <Link to="/home" className='left-icon-link'>
                    <IoClose className='icon' />
                </Link>

                {isFeedbackOpen && <Feedback onClose={toggleFeedback} />}
                {isQueryOpen && <Query onClose={toggleQuery} />}


                <div className="logo-div">
                    <img src={logo} alt="" />
                </div>

                <form className="login signup-form" onSubmit={onSubmit}>
                    {/* Nickname Input */}
                    <div className="form-input">
                        <label htmlFor="newPwd">New password</label>
                        <input 
                            type="password" 
                            id="newPwd" 
                            name="password" 
                            placeholder="****" 
                            value={pwd1}
                            onChange={(e) => setPwd1(e.target.value)}
                            autoComplete='off'
                        />
                    </div>


                    {/* Password Input */}
                    <div className="form-input">
                        <label htmlFor="confirmPwd">Confirm Password</label>
                        <input 
                            type="password" 
                            id="confirmPwd" 
                            name="confirmPwd" 
                            placeholder="****" 
                            value={pwd2}
                            onChange={(e) => setPwd2(e.target.value)}
                            autoComplete='off'
                        />
                    </div>
        

                    {/* Submit Button */}
                    <button type="submit" className="signup-button" disabled={submitting}>
                        <p className='btn-text'>{submitting ? 'Saving…' : 'Reset password'}</p>
                    </button>

                    {/* Login Link */}
                    <p className="login-text">
                      This link expires in 15 minutes.
                    </p>
                </form>

                <Footer onOpenFeedback={toggleFeedback} onOpenQuery={toggleQuery}/>
            </section>

            
        </>
            
    );
};

export default LogIn;
